export default "__VITE_ASSET__DnPuRJtH__"